module.exports = __webpack_public_path__ + "static/media/WIACP.8e4d929d.png";